export default "/images/arrow_down_filter.svg?41fbc68b511b25f37c104020269afc0e";